<template>
  <vs-popup
    fullscreen
    :active.sync="isActiveLocal"
    title="Yeni Fatura Oluştur"
    v-esc="escape"
    id="newBillPopup"
  >
    <div v-show="newBillStep == 0" class="py-3 px-4">
      <vs-row vs-type="flex" vs-w="12" class="mb-2">
        <vs-col vs-type="flex" vs-w="12" vs-align="center">
          <v-select
            v-model="selectedBranch"
            itemid="id"
            label="name"
            class="w-full"
            v-if="$isCenterBranch() || $isRegionalCenterBranch()"
            placeholder="Şube Seçimi.."
            :options="$currentUser.branch.id == 1 ? branches : []"
            :clearable="false"
          >
          </v-select>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mb-2">
        <vs-col vs-type="flex" vs-w="6" class="pr-2">
          <v-select
            v-model="selectedSupplier"
            itemid="id"
            label="name"
            v-if="selectedBranch != null"
            class="w-full"
            placeholder="Tedarikçi Seçimi.."
            :options="suppliers"
            :clearable="false"
            v-validate="{ required: true }"
          >
          </v-select>
        </vs-col>
        <vs-col vs-type="flex" vs-w="6" class="pl-2">
          <v-select
            v-model="selectedDistributor"
            itemid="id"
            label="name"
            v-if="selectedSupplier != null && distributors.length > 0"
            class="w-full"
            placeholder="Distribütor Seçimi.."
            :options="distributors"
            :clearable="false"
            v-validate="{ required: true }"
          >
          </v-select>
        </vs-col>
      </vs-row>
      <vs-table :data="newBill.billEntries" id="newBillEntryList">
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        ></div>
        <template slot="thead">
          <vs-th class="w-3/12"> Stok İsim </vs-th>
          <vs-th class="w-1/12"> Birim </vs-th>
          <vs-th class="w-1/12"> B.Fiyatı ₺ </vs-th>
          <vs-th class="w-1/12"> Miktar </vs-th>
          <vs-th class="w-2/12"> İskonto </vs-th>
          <vs-th class="w-1/12"> Kdv % </vs-th>
          <vs-th class="w-2/12"> Toplam Tutar </vs-th>
          <vs-th class="w-1/12"> İşlem </vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="w-3/12">
                <v-select
                  :disabled="rawMaterialsByStock.length == 0"
                  id="product"
                  name="Ürün"
                  v-validate="'required'"
                  v-model="tr.rawMaterial"
                  @input="(val) => onRawMaterialSelect(val, indextr)"
                  itemid="id"
                  label="name"
                  placeholder="Stok Seçimi.."
                  :options="rawMaterialsByStock"
                  :clearable="false"
                ></v-select>
                <span
                  class="text-danger text-xsmall"
                  v-show="errors.has('Ürün')"
                  >{{ errors.first("Ürün") }}</span
                >
              </vs-td>

              <vs-td class="w-1/12">
                <v-select
                  id="unit"
                  name="Birim"
                  v-model="tr.unit"
                  v-if="tr.rawMaterial && tr.rawMaterial.alternateUnits"
                  itemid="id"
                  label="name"
                  @input="convertUnit(tr)"
                  :disabled="tr.isDiscounted || tr.isTaxed"
                  :options="tr.rawMaterial.alternateUnits"
                  :clearable="false"
                >
                </v-select>
              </vs-td>

              <vs-td class="w-1/12" v-if="true">
                <vs-input
                  id="buyPrice"
                  :disabled="tr.isDiscounted || tr.isTaxed"
                  :name="indextr + 1 + '.Birim Fiyatı'"
                  v-if="tr.rawMaterial"
                  v-validate="{
                    required: true,
                    regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                  }"
                  v-model="tr.rawMaterial.buyPrice"
                  class="w-full"
                  @input="setTypedBuyPrice(tr.rawMaterial)"
                />
                <span
                  class="text-danger text-xsmall"
                  v-show="errors.has(indextr + 1 + '.Birim Fiyatı')"
                  >{{ errors.first(indextr + 1 + ".Birim Fiyatı") }}</span
                >
              </vs-td>

              <vs-td class="w-1/12" v-if="false">
                <span v-if="tr.rawMaterial">
                  {{ $toCurrency(tr.rawMaterial.buyPrice, 2) }}
                </span>
              </vs-td>

              <vs-td class="w-1/12">
                <vs-input
                  id="quantity"
                  :name="indextr + 1 + '.Miktar'"
                  v-if="tr.rawMaterial"
                  :disabled="tr.isDiscounted"
                  v-validate="{
                    min_value: 1,
                    required: true,
                    regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                  }"
                  v-model="tr.quantity"
                  class="w-full"
                  placeholder="Miktar"
                />
                <span
                  class="text-danger text-xsmall"
                  v-show="errors.has(indextr + 1 + '.Miktar')"
                  >{{ errors.first(indextr + 1 + ".Miktar") }}</span
                >
              </vs-td>

              <vs-td class="w-1/12">
                <vs-row vs-type="flex" vs-w="12" v-if="tr.rawMaterial">
                  <vs-col
                    vs-type="flex"
                    vs-w="5"
                    vs-justify="center"
                    vs-align="center"
                  >
                    <vs-input
                      id="discountByEntry"
                      :name="indextr + 1 + '.İskonto'"
                      :disabled="tr.isDiscounted"
                      v-validate="{ regex: /^\d{0,10}(\.\d{0,10}){0,1}$/ }"
                      v-model="tr.discount"
                      class="w-full"
                    />
                    <span
                      class="text-danger text-xsmall"
                      v-show="errors.has(indextr + 1 + '.İskonto')"
                      >{{ errors.first(indextr + 1 + ".İskonto") }}</span
                    >
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-w="4"
                    vs-justify="center"
                    vs-align="center"
                  >
                    <v-select
                      class="w-full"
                      id="discountType"
                      name="İskonto Tipi"
                      v-model="tr.discountType"
                      :disabled="tr.isDiscounted"
                      v-if="tr.rawMaterial && tr.rawMaterial.alternateUnits"
                      itemid="id"
                      label="name"
                      :options="discountTypes"
                      :clearable="false"
                    >
                    </v-select>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-w="3"
                    vs-justify="center"
                    vs-align="center"
                  >
                    <vx-tooltip
                      color="primary"
                      title="Miktar'dan İskonto Uygula"
                      v-if="tr.isDiscounted == false"
                      text="Eğer uygulanmaz ise sistem Birim Fiyatını iskonto uygulanmış kabul eder."
                    >
                      <vs-button
                        class="disableSecondary"
                        radius
                        @click="applyDiscount(tr, false)"
                        type="filled"
                        size="small"
                        :disabled="
                          !isDiscountable(tr) ||
                          tr.isTaxed ||
                          tr.discount == 0 ||
                          tr.quantity == 0 ||
                          tr.quantity == null
                        "
                        color="primary"
                        icon-pack="feather"
                        icon="icon-corner-down-left"
                      />
                    </vx-tooltip>
                    <vx-tooltip
                      color="success"
                      title="İskonto Uygulandı !"
                      text="Uygulanan iskontoyu tekrar tıklayarak geri alabilirisin."
                      v-if="tr.isDiscounted == true"
                    >
                      <vs-button
                        class="disableSecondary"
                        :disabled="tr.isTaxed"
                        radius
                        @click="rollBackDiscount(tr)"
                        type="filled"
                        size="small"
                        color="success"
                        icon-pack="feather"
                        icon="icon-check"
                      />
                    </vx-tooltip>
                  </vs-col>
                </vs-row>
              </vs-td>

              <vs-td class="w-1/12">
                <vs-row
                  vs-type="flex"
                  vs-w="12"
                  v-if="tr.rawMaterial"
                  vs-justify="space-between"
                  vs-align="center"
                >
                  <vs-col vs-type="flex" vs-w="7" vs-justify="center">
                    <v-select
                      class="w-full"
                      id="kdvValue"
                      name="KDV"
                      v-model="tr.rawMaterial.kdv"
                      :disabled="tr.isTaxed"
                      v-if="tr.rawMaterial && tr.rawMaterial.alternateUnits"
                      itemid="id"
                      label="name"
                      :options="kdvValues"
                      :clearable="false"
                    >
                    </v-select>
                  </vs-col>
                  <vs-col vs-type="flex" vs-w="3" vs-justify="center">
                    <vx-tooltip
                      color="primary"
                      title="Kdv Uygula"
                      v-if="tr.isTaxed == false"
                      text="Eğer uygulanmaz ise sistem Birim Fiyatını Kdv Dahil olarak kabul eder."
                    >
                      <vs-button
                        class="disableSecondary"
                        radius
                        @click="applyTax(tr)"
                        type="filled"
                        :disabled="
                          !isTaxable(tr) ||
                          tr.quantity == 0 ||
                          tr.quantity == null
                        "
                        color="primary"
                        icon-pack="feather"
                        icon="icon-corner-down-left"
                        size="small"
                      />
                    </vx-tooltip>
                    <vx-tooltip
                      color="success"
                      title="Kdv Uygulandı !"
                      text="Uygulanmış olan Kdv'yi tekrar tıklayarak geri alabilirsin."
                      v-if="tr.isTaxed == true"
                    >
                      <vs-button
                        class="disableSecondary"
                        radius
                        @click="rollBackTax(tr)"
                        type="filled"
                        color="success"
                        icon-pack="feather"
                        size="small"
                        icon="icon-check"
                      />
                    </vx-tooltip>
                  </vs-col>
                </vs-row>
              </vs-td>

              <vs-td class="w-2/12 text-center">
                <vx-tooltip
                  color="primary"
                  v-if="
                    tr.rawMaterial &&
                    tr.unit &&
                    tr.rawMaterial.alternateUnits &&
                    !errors.has(indextr + 1 + '.Miktar') &&
                    tr.quantity != null &&
                    !errors.has(indextr + 1 + '.Birim Fiyatı')
                  "
                >
                  <span
                    :ref="indextr + 'spanDD'"
                    class="text-primary text-smaller weight-600"
                    :class="{
                      underline: !tr.isDiscounted && !tr.isTaxed && false,
                    }"
                  >
                    {{ priceByRow(tr) }}
                  </span>
                </vx-tooltip>
              </vs-td>

              <vs-td class="w-1/12 whitespace-no-wrap text-center">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="newBill.billEntries.splice(indextr, 1)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
          <vs-button
            :disabled="
              selectedBranch === null ||
              (newBill.distributor == null && distributors.length > 0)
            "
            type="gradient"
            icon-pack="feather"
            icon="icon-plus"
            class="m-4"
            @click="addStock"
          >
          </vs-button>
        </template>
      </vs-table>
      <vs-row vs-type="flex" vs-w="12">
        <span class="ml-auto h4"
          >Toplam : {{ $toCurrency(totalBuyPrice, 2) }}
        </span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="space-between" vs-w="12" class="mt-4">
        <vs-button
          size="large"
          icon-pack="feather"
          icon="icon-x"
          class="mr-auto"
          type="gradient"
          color="danger"
          @click="isActiveLocal = false"
        >
          Vazgeç
        </vs-button>
        <vs-button
          type="gradient"
          icon-pack="feather"
          icon="icon-arrow-right"
          class="ml-auto"
          color="success"
          @click="goNextStep"
          size="large"
          >İlerle</vs-button
        >
      </vs-row>
    </div>
    <div v-if="newBillStep == 1">
      <vs-row id="billDetailRow" vs-type="flex" vs-w="12">
        <vs-col
          id="billDetailHeadersCol"
          vs-type="flex"
          vs-w="4.5"
          class="py-3 px-4"
        >
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" class="py-3">
              <span class="px-2 text-primary text-medium-small bold">
                Fatura Bilgileri
              </span>
            </vs-row>
            <vs-divider class="box-shadow-divider m-0"></vs-divider>
            <vs-row vs-type="flex" vs-w="12" class="py-3">
              <vs-col
                vs-type="block"
                vs-w="6"
                vs-justify="flex-start"
                vs-align="center"
              >
                <span class="text-primary block text-small bold text-center">
                  Şube
                </span>
                <span class="text-dark block text-small weight-500 text-center">
                  {{ selectedBranch.name }}
                </span>
              </vs-col>
              <vs-col
                vs-type="block"
                vs-w="6"
                vs-justify="flex-end"
                vs-align="center"
              >
                <span class="text-primary block text-small bold text-center">
                  Tarih
                </span>
                <span class="text-dark text-small block weight-500 text-center">
                  <vs-row vs-type="flex" vs-w="12">
                    <datepicker
                      class="w-full"
                      v-model="newBill.billDate"
                      :language="turkish"
                      format="yyyy MMM d"
                    />
                  </vs-row>
                </span>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="pb-2">
              <vs-col vs-type="block" vs-w="12">
                <span class="text-primary block text-small bold text-center">
                  Tedarikçi
                </span>
                <span class="text-dark block text-small weight-500 text-center">
                  {{
                    newBill.supplier.name +
                    " - " +
                    (newBill.distributor != null
                      ? newBill.distributor.name
                      : "")
                  }}
                </span>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="pb-2">
              <vs-col
                vs-type="block"
                vs-w="6"
                vs-justify="center"
                vs-align="center"
              >
                <span class="text-primary block text-small bold text-center">
                  Toplam Kdv Tutarı
                </span>
                <span
                  class="text-dark block text-medium-small weight-600 text-center"
                >
                  {{ $toCurrency(newBill.totalKdvPrice, 2) }}
                </span>
              </vs-col>
              <vs-col
                vs-type="block"
                vs-w="6"
                vs-justify="center"
                vs-align="center"
              >
                <span class="text-primary block text-small bold text-center">
                  Toplam Tutar
                </span>
                <span
                  class="text-dark block text-medium bold text-center"
                  style="margin-top: -5px"
                >
                  {{ $toCurrency(totalBuyPrice, 2) }}
                </span>
              </vs-col>
            </vs-row>
            <vs-divider class="box-shadow-divider m-0"></vs-divider>
            <vs-row vs-type="flex" vs-w="12" class="py-3">
              <vs-col
                vs-type="block"
                vs-w="6"
                vs-justify="center"
                vs-align="center"
                class="px-2"
              >
                <span class="text-primary text-center block text-small bold">
                  Ödeme Tipi
                </span>
                <v-select
                  class="text-dark weight-600 px-5"
                  name="Ödeme Tipi"
                  @change="setSavedPriceZero"
                  v-model="newBill.paymentMethod"
                  itemid="id"
                  label="name"
                  :options="paymentMethods"
                  :clearable="false"
                />
              </vs-col>
              <vs-col
                vs-type="block"
                vs-w="6"
                vs-justify="center"
                v-if="newBill.id == 0"
                vs-align="center"
              >
                <span class="text-primary text-center block text-small bold">
                  Fatura İskonto
                </span>
                <vs-row
                  vs-type="flex"
                  vs-w="12"
                  vs-justify="center"
                  vs-align="center"
                >
                  <vs-col
                    vs-type="flex"
                    vs-w="5"
                    vs-justify="center"
                    vs-align="center"
                  >
                    <vs-input
                      id="discountByTotal"
                      name="Fatura İskonto"
                      size="small"
                      :disabled="newBill.isDiscounted"
                      v-validate="{
                        required: true,
                        regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                      }"
                      v-model="newBill.totalDiscount"
                      class="w-full text-primary"
                    />
                    <span
                      class="text-danger text-xsmaller"
                      v-show="errors.has('Fatura İskonto')"
                      >{{ errors.first("Fatura İskonto") }}</span
                    >
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-w="3"
                    vs-justify="center"
                    vs-align="center"
                  >
                    <v-select
                      class="w-full"
                      id="discountType"
                      name="İskonto Tipi"
                      v-model="newBill.totalDiscountType"
                      :disabled="newBill.isDiscounted"
                      itemid="id"
                      label="name"
                      :options="discountTypes"
                      :clearable="false"
                    >
                    </v-select>
                  </vs-col>
                  <vs-col
                    v-if="false"
                    vs-type="flex"
                    vs-w="2"
                    vs-justify="center"
                    vs-align="center"
                  >
                    <vx-tooltip
                      color="success"
                      title="Tüm Faturaya İskonto Uygula"
                      v-if="newBill.isDiscounted == false"
                      text="İskonto uygulandığında girilen değerce tüm satırlara orantılı olarak iskonto uygulanır. Eğer uygulanmaz ise sistem Birim Fiyatını iskonto uygulanmış kabul eder."
                    >
                      <vs-button
                        radius
                        @click="applyTotalDiscount"
                        type="filled"
                        class="disableSecondary"
                        :disabled="
                          !isTotalDiscountable() || newBill.totalDiscount <= 0
                        "
                        color="primary"
                        icon-pack="feather"
                        icon="icon-corner-down-left"
                        size="small"
                      />
                    </vx-tooltip>
                    <vx-tooltip
                      color="warning"
                      title="Tüm Fatura İskontosunu Uygulandı !"
                      text="Uygulanan iskontoyu tekrar tıklayarak geri alabilirsin."
                      v-if="newBill.isDiscounted == true"
                    >
                      <vs-button
                        radius
                        @click="rollBackTotalDiscount"
                        type="filled"
                        color="success"
                        icon-pack="feather"
                        class="disableSecondary"
                        icon="icon-check"
                        size="small"
                      />
                    </vx-tooltip>
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              class="pb-3"
              v-if="newBill.id == 0"
            >
              <vs-col
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-textarea
                  id="billDescription"
                  v-validate="'max:100'"
                  v-model="newBill.description"
                  class="w-full mb-0"
                  label="Açıklama"
                />
              </vs-col>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              class="pb-3"
              v-if="newBill.id == 0"
            >
              <vs-col
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
                style="flex-direction: column;"
              >
                <!-- Fatura Görseli Önizleme -->
                <div v-if="newBill.fileUrl" class="w-full relative mt-2 text-center" style="border: 1px solid #ccc; padding: 5px; border-radius: 8px;">
                  <template v-if="newBill.fileUrl.toLowerCase().endsWith('.pdf')">
                    <div style="height: 150px; display: flex; flex-direction: column; align-items: center; justify-content: center; background: #f8f8f8; border-radius: 8px;">
                      <vs-icon icon-pack="feather" icon="icon-file-text" size="40px" color="primary"></vs-icon>
                      <span class="mt-2 font-medium text-primary">PDF Belgesi Seçildi</span>
                    </div>
                  </template>
                  <template v-else>
                    <img :src="getAbsoluteUrl(newBill.fileUrl)" alt="Fatura Görseli" style="max-height: 150px; border-radius: 8px; object-fit: cover; width: 100%;">
                  </template>
                  <vs-button radius color="danger" type="filled" icon-pack="feather" icon="icon-x" style="position: absolute; top: -10px; right: 0px;" @click="newBill.fileUrl = null"></vs-button>
                </div>
                
                <vs-button color="primary" type="border" icon-pack="feather" icon="icon-file-text" class="w-full mt-2" style="border-style: dashed !important; border-width: 2px;" @click="$refs.billImageInput.click()">
                  {{ newBill.fileUrl ? 'Fatura Belgesini Değiştir' : 'Fatura Belgesi Ekle (Resim/PDF)' }}
                </vs-button>
                <input type="file" ref="billImageInput" class="hidden" accept="image/*,application/pdf" capture="environment" @change="onImageSelected" style="display: none;">
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12">
              <vs-col
                vs-type="flex"
                vs-w="6"
                class="px-2"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-arrow-left"
                  color="danger"
                  @click="newBillStep -= 1"
                  >Geri Dön</vs-button
                >
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="6"
                class="px-2"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-save"
                  color="success"
                  @click="submitData"
                >
                  Kaydet</vs-button
                >
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-col>
        <vs-col id="billEntryListCol" vs-type="flex" vs-w="7.5">
          <vs-row
            vs-type="block"
            vs-w="12"
            vs-justify="center"
            vs-align="center"
            class="py-3 px-4"
            id="billEntryListContent"
          >
            <vs-row
              vs-type="flex"
              vs-w="12"
              vs-justify="flex-start"
              vs-align="center"
              class="py-3"
              id="billEntryListContentHead"
            >
              <span class="px-2 text-primary text-medium-small bold">
                Ürün Bilgileri
              </span>
            </vs-row>
            <vs-divider class="box-shadow-divider m-0"></vs-divider>
            <vs-row
              vs-type="flex"
              vs-w="12"
              class="py-3 px-2"
              id="billEntry"
              v-for="(entry, index) in newBill.billEntries"
              :key="index"
            >
              <vs-col
                vs-type="flex"
                vs-w="9"
                vs-justify="flex-start"
                id="billEntryDetail"
              >
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-dark text-medium-small bold">
                      {{ entry.rawMaterial.name }}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" class="px-2">
                    <span class="text-primary text-smaller weight-600">
                      {{ entry.quantity + " " + entry.unit.name + " |" }}
                    </span>
                    <span class="text-secondary text-smaller weight-600 ml-1">
                      {{
                        entry.discount +
                        " " +
                        entry.discountType.name +
                        " Kalem İskontosu"
                      }}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" class="px-2">
                    <span class="text-primary text-xsmall weight-600">
                      {{
                        "Birim Fiyatı : " +
                        $toCurrency(entry.rawMaterial.buyPrice, 2) +
                        " |"
                      }}
                    </span>
                    <span class="text-secondary text-xsmall weight-600 ml-1">
                      {{
                        "Ara Toplam : " +
                        $toCurrency(
                          ((entry.rawMaterial.buyPrice * entry.quantity -
                            entry.kdvPrice) *
                            1000) /
                            1000,
                          2
                        ) +
                        " |"
                      }}
                    </span>
                    <span class="text-secondary text-xsmall weight-600 ml-1">
                      {{
                        "KDV : " +
                        entry.rawMaterial.kdv +
                        "%" +
                        " (" +
                        $toCurrency(entry.kdvPrice, 2) +
                        ")"
                      }}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
              <vs-col vs-type="flex" vs-w="3" vs-justify="center">
                <span class="text-medium text-dark bold">
                  {{
                    $toCurrency(
                      (entry.rawMaterial.buyPrice * entry.quantity * 1000) /
                        1000,
                      2
                    )
                  }}
                </span>
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
import { getDefaultPaymentMethods } from "../../../model/constants/DefaultPaymentMethods";
import {
  getDistributorNameList,
  getSupplierNameSelectList,
} from "@/api/Supplier.js";
import { getBranchNameList2 } from "@/api/Branch";
import { getStockNameListByDistributor } from "@/api/Stock";
import { getAlternateUnits, findRateToRoot, convertUnit } from "@/api/Unit";
import Datepicker from "vuejs-datepicker";
import { saveNewStocks, uploadImage } from "@/api/Bill";
export default {
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isEditMode: false,
      distributors: [],
      suppliers: [],
      selectedDistributor: null,
      selectedSupplier: null,
      paymentMethods: [],
      kdvValues: [0, 1, 8, 12, 18],
      kdvTypes: [
        {
          id: 1,
          name: "Dahil",
        },
        {
          id: 2,
          name: "Dahil Değil",
        },
      ],
      discountTypes: [
        {
          val: false,
          name: "₺",
        },
        {
          val: true,
          name: "%",
        },
      ],
      totalDiscountPercent: null,
      newBillStep: 0,
      tempTotalPrice: null,
      tempTotalQuantity: null,
      discountType: false,
      rawMaterialsByStock: [],
      stocks: [],
      branches: [],
      selectedBranch: null,
      newBill: {
        id: 0,
        isDiscounted: false,
        savedPrice: 0,
        isSolid: false,
        leftPrice: 0,
        commitedPrice: 0,
        fileUrl: null,
        totalDiscountType: {
          val: false,
          name: "₺",
        },
        totalDiscount: 0,
        billEntries: [],
        paymentMethod: {
          id: 1,
          name: "Nakit",
        },
      },
    };
  },
  methods: {
    convertUnit(tr) {
      let unitId = tr.unit.id;
      let stockId = tr.stockId;
      let quantity = tr.rawMaterial.buyPrice;
      if (!unitId) return;
      convertUnit(unitId, stockId)
        .then((res) => {
          if (res && res.status === 200) {
            tr.rawMaterial.preUnitId = tr.unit.id;
            tr.rawMaterial.buyPrice = res.data;
            tr.rawMaterial.typedBuyPrice = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Birim Çevirme Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    onImageSelected(e) {
      const file = e.target.files[0];
      if (!file) return;

      this.$vs.loading();
      let formData = new FormData();
      formData.append("image", file);

      uploadImage(formData)
        .then((res) => {
          if (res && res.status === 200) {
            this.$set(this.newBill, 'fileUrl', "StaticFiles/Bills/" + res.data);
            this.$vs.notify({ color: "success", title: "Başarılı", text: "Fatura belgesi yüklendi." });
          } else {
            this.$vs.notify({ color: "danger", title: "Hata", text: "Belge yüklenemedi!" });
          }
        })
        .catch(() => {
          this.$vs.notify({ color: "danger", title: "Hata", text: "Sunucu bağlantı hatası." });
        })
        .finally(() => {
          this.$vs.loading.close();
          this.$refs.billImageInput.value = '';
        });
    },
    getAbsoluteUrl(path) {
      if (!path) return '';
      if (path.startsWith('http')) return path;
      if (path.startsWith('/')) path = path.substring(1);
      return process.env.VUE_APP_ROOT_API + '/' + path;
    },
    getDistributorNameList() {
      let payload = {
        supplierId: this.selectedSupplier.id,
        branchId: this.selectedBranch.id,
      };
      getDistributorNameList(payload)
        .then((res) => {
          if (res && res.status == 200) {
            this.distributors = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Distributorler Listelenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getSupplierNameSelectList() {
      getSupplierNameSelectList()
        .then((res) => {
          if (res && res.status == 200) {
            this.suppliers = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Tedarikçiler Listelenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    setSavedPriceZero(val) {
      if (val.id == 10) this.newBill.savedPrice = 0;
    },
    setTypedBuyPrice(val) {
      val.typedBuyPrice = val.buyPrice;
    },
    isTaxable(row) {
      if (isNaN(row.rawMaterial.kdv || row.rawMaterial.kdv <= 0)) return false;
      if (row.rawMaterial.buyPrice != null && row.rawMaterial.buyPrice > 0)
        return true;
      else return false;
    },
    applyTax(row) {
      let buyPriceWithDiscount = row.isDiscounted
        ? this.applyDiscount(row, true)
        : row.rawMaterial.buyPrice;
      let kdv = (buyPriceWithDiscount * row.rawMaterial.kdv) / 100;
      let newPrice = parseFloat(kdv) + parseFloat(buyPriceWithDiscount);
      row.rawMaterial.buyPrice = Math.round(newPrice * 1000) / 1000;
      row.isTaxed = true;
    },
    rollBackTax(row) {
      if (row.isDiscounted) {
        this.applyDiscount(row, false);
        row.isTaxed = false;
      } else {
        row.rawMaterial.buyPrice = row.rawMaterial.typedBuyPrice;
        row.isTaxed = false;
      }
    },
    goNextStep: async function () {
      let checker = await this.$validator.validateAll();
      if (!checker) return;
      this.setKdvPriceRow();
      this.newBillStep += 1;
    },
    setKdvPriceRow() {
      this.newBill.totalKdvPrice = 0;
      this.newBill.billEntries.forEach((entry) => {
        if (entry.isTaxed == false)
          entry.kdvPrice =
            (entry.rawMaterial.buyPrice *
              entry.quantity *
              entry.rawMaterial.kdv) /
            100;
        else
          entry.kdvPrice =
            entry.rawMaterial.buyPrice * entry.quantity -
            ((entry.rawMaterial.buyPrice * 100) /
              (100 + entry.rawMaterial.kdv)) *
              entry.quantity;
        entry.kdvPrice = Math.round(entry.kdvPrice * 1000) / 1000;
        this.newBill.totalKdvPrice += entry.kdvPrice;
      });
    },
    undoTotalDiscount() {
      this.newBill.billEntries.forEach((entry) => {
        let oldPrice = entry.beforeBillDiscountBuyPrice;
        entry.rawMaterial.buyPrice = oldPrice;
        this.setKdvPriceRow();
      });
    },
    doTotalDiscount(percent) {
      this.newBill.billEntries.forEach((entry) => {
        let oldPrice = entry.rawMaterial.buyPrice;
        entry.beforeBillDiscountBuyPrice = oldPrice;
        let totalPrice = entry.rawMaterial.buyPrice * entry.quantity;
        entry.rawMaterial.buyPrice =
          Math.round(
            ((totalPrice - (totalPrice * percent) / 100) / entry.quantity) *
              1000
          ) / 1000;
        this.setKdvPriceRow();
      });
    },
    applyTotalDiscount() {
      switch (this.newBill.totalDiscountType.val) {
        case false: // ₺ ise
          this.totalDiscountPercent =
            (this.newBill.totalDiscount * 100) / this.totalBuyPrice;
          this.doTotalDiscount(this.totalDiscountPercent);
          break;
        case true: // % ise
          this.doTotalDiscount(this.newBill.totalDiscount);
          break;
      }
      this.newBill.isDiscounted = true;
    },
    isTotalDiscountable() {
      switch (this.newBill.totalDiscountType.val) {
        case false:
          if (this.totalBuyPrice > this.newBill.totalDiscount) return true;
          else return false;
        case true:
          if (this.newBill.totalDiscount > 100) return false;
          else return true;
      }
    },
    rollBackTotalDiscount() {
      switch (this.newBill.totalDiscountType.val) {
        case false:
          this.undoTotalDiscount(this.totalDiscountPercent);
          break;

        case true:
          this.undoTotalDiscount(this.newBill.totalDiscount);
          break;
      }
      this.newBill.isDiscounted = false;
    },
    syncTempRowWithOrigin(row, indextr) {
      let temp =
        Math.round((this.tempTotalPrice / this.tempTotalQuantity) * 1000) /
        1000;
      row.rawMaterial.buyPrice = temp;
      row.rawMaterial.typedBuyPrice = temp;
      row.quantity = this.tempTotalQuantity;
      this.tempTotalQuantity = null;
      this.tempTotalPrice = null;
      row.isTaxed = false;
      row.isDiscounted = false;
      row.discountType = {
        val: false,
        name: "₺",
      };
      Object.values(this.$refs)[indextr][0].click();
    },
    rollBackDiscount(row) {
      row.rawMaterial.buyPrice = row.rawMaterial.typedBuyPrice;
      row.isDiscounted = false;
    },
    applyDiscount(row, isRaw) {
      let totalPrice = row.rawMaterial.typedBuyPrice * row.quantity;
      let newPrice = 0;
      switch (row.discountType.val) {
        case false:
          newPrice = (totalPrice - row.discount) / row.quantity;
          break;

        case true:
          newPrice =
            (totalPrice - (totalPrice * row.discount) / 100) / row.quantity;
          break;
      }
      if (!isRaw) {
        row.rawMaterial.buyPrice = Math.round(newPrice * 1000) / 1000;
        row.isDiscounted = true;
      } else {
        return newPrice;
      }
    },
    isDiscountable(row) {
      if (row.quantity == null || !(row.quantity > 0)) return false;
      switch (row.discountType.val) {
        case false:
          if (row.rawMaterial.buyPrice * row.quantity >= row.discount)
            return true;
          else return false;
        case true:
          if (row.discount > 100) return false;
          else return true;
      }
    },
    priceByRow(row) {
      let totalPrice = this.$toCurrency(
        Math.round(row.rawMaterial.buyPrice * row.quantity * 1000) / 1000,
        2
      );
      return totalPrice;
    },
    findRateToRoot(selectedUnit) {
      if (selectedUnit.originUnitId != null)
        findRateToRoot(selectedUnit.id)
          .then((res) => {
            if (res && res.status == 200) {
              selectedUnit.originUnitQuantity = res.data;
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Birim Çevirme Başarısız ! ",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası ! ",
            });
          });
    },
    escape() {
      if (this.isActiveLocal == true) this.isActiveLocal = false;
    },
    placeId(stockRow) {
      let rawMaterialInStock = this.stocks.find(
        (x) => x.rawMaterial.id == stockRow.rawMaterial.id
      );
      stockRow.stockId = rawMaterialInStock.id;
      stockRow.branch = rawMaterialInStock.branch;
      stockRow.rawMaterial.type;
    },
    getStockNameListByDistributor: function () {
      let payload = {
        supplierId: this.selectedSupplier.id,
        branchId: this.selectedBranch.id,
      };
      getStockNameListByDistributor(payload)
        .then((res) => {
          if (res && res.status == 200) {
            this.stocks = res.data;
            this.rawMaterialsByStock = res.data.map((x) => {
              return x.rawMaterial;
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Stok Listesi Yüklenemedi ! ",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata ! ",
            text: "Sunucu Bağlantı Hatası ! ",
          });
        });
    },
    onRawMaterialSelect(val, indextr) {
      // Her satıra yeni bir rawMaterial objesi atansın
      const clonedRawMaterial = JSON.parse(JSON.stringify(val));
      this.newBill.billEntries[indextr].rawMaterial = clonedRawMaterial;
      // Unit'i de sıfırla
      this.newBill.billEntries[indextr].unit = null;
      // Alternatif birimleri de deep clone ile ata
      this.getAlternateUnits(clonedRawMaterial, indextr);
      this.placeId(this.newBill.billEntries[indextr]);
      this.setTypedBuyPrice(clonedRawMaterial);
    },
    getAlternateUnits: function (val, index) {
      getAlternateUnits(val.unit.id)
        .then((res) => {
          if (res && res.status == 200) {
            var alternateUnits = res.data;
            alternateUnits.forEach((alternateUnit) => {
              if (
                alternateUnit.originUnitQuantity == null &&
                alternateUnit.originUnitId == null
              )
                alternateUnit.originUnitQuantity = 1;
              else {
                var parentUnit = alternateUnits.find(
                  (x) => x.id == alternateUnit.originUnitId
                );

                while (parentUnit != null) {
                  alternateUnit.originUnitQuantity =
                    alternateUnit.originUnitQuantity *
                    parentUnit.originUnitQuantity;
                  var checkForParent = alternateUnits.indexOf(
                    (x) => x.id == alternateUnit.originUnitId
                  );
                  if (checkForParent > 0)
                    parentUnit = alternateUnits.find(
                      (x) => x.id == parentUnit.originUnitId
                    );
                  else parentUnit = null;
                }
              }
            });

            val.alternateUnits = JSON.parse(JSON.stringify(alternateUnits));
            this.newBill.billEntries[index].unit = val.alternateUnits[0]
              ? JSON.parse(JSON.stringify(val.alternateUnits[0]))
              : null;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Alternatif Birimler Yüklenemedi ! ",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: error,
            text: "Sunucu Bağlantı Hatası ! ",
          });
        });
    },
    addStock() {
      this.newBill.billEntries.push({
        rawMaterial: null,
        quantity: null,
        unit: null,
        id: 0,
        kdvPrice: 0,
        stockId: null,
        discount: 0,
        discountType: {
          val: false,
          name: "₺",
        },
        isDiscounted: false,
        isTaxed: false,
      });
    },
    initValues() {
      this.totalDiscountPercent = null;
      this.newBillStep = 0;
      this.tempTotalPrice = null;
      this.tempTotalQuantity = null;
      this.discountType = false;
      this.selectedDistributor = null;
      this.selectedSupplier = null;
      this.newBill = {
        id: 0,
        isDiscounted: false,
        totalDiscount: 0,
        totalDiscountType: {
          val: false,
          name: "₺",
        },
        billEntries: [],
        paymentMethod: {
          id: 1,
          name: "Nakit",
        },
      };
      this.selectedBranch = null;
      this.stocks = [];
      this.rawMaterialsByStock = [];
    },
    submitData: async function () {
      let checker;
      checker = await this.$validator.validateAll();
      if (checker) {
        this.newBill.totalPrice = parseFloat(this.totalBuyPrice.toFixed(2));
        this.newBill.branch = this.selectedBranch;
        this.newBill.totalKdvPrice = this.newBill.totalKdvPrice
          ? parseFloat(this.newBill.totalKdvPrice)
          : 0;
        this.newBill.savedPrice = this.newBill.savedPrice
          ? parseFloat(this.newBill.savedPrice)
          : 0;
        this.newBill.commitedPrice = this.newBill.commitedPrice
          ? parseFloat(this.newBill.commitedPrice)
          : 0;
        this.newBill.leftPrice = this.newBill.leftPrice
          ? parseFloat(this.newBill.leftPrice)
          : 0;
        this.newBill.totalDiscount = this.newBill.totalDiscount
          ? parseFloat(this.newBill.totalDiscount)
          : 0;
        this.newBill.billEntries.forEach((x) => {
          x.quantity = parseFloat(x.quantity);
          x.unitPrice = x.rawMaterial.buyPrice
            ? parseFloat(x.rawMaterial.buyPrice)
            : 0;
          x.kdvPrice = parseFloat(x.kdvPrice);
          x.discount = x.discount ? parseFloat(x.discount) : 0;
        });
        saveNewStocks(this.newBill)
          .then((res) => {
            if (res && res.status == 200) {
              this.$store.dispatch("bill/addBill", res.data).then(() => {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Fatura Oluşturma İşlemi Başarılı !",
                });
                this.$emit("close");
                this.initValues();
                this.$validator.reset();
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Fatura Oluşturma İşlemi Başarısız ! ",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
  },
  components: {
    Datepicker,
  },
  computed: {
    today() {
      var today = this.$now.date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0");
      var yyyy = today.getFullYear();

      today = mm + "/" + dd + "/" + yyyy;
      return today;
    },
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.$emit("close");
          this.initValues();
          this.$validator.reset();
        }
      },
    },
    totalBuyPrice: function () {
      let totalByRow = this.newBill.billEntries.reduce(function (total, num) {
        let totalBuyPrice =
          total +
          (num.rawMaterial != null &&
          num.rawMaterial.buyPrice != 0 &&
          num.quantity != null
            ? num.rawMaterial.buyPrice * num.quantity
            : 0);

        return Math.round(totalBuyPrice * 1000) / 1000;
      }, 0);
      if (
        !this.newBill.totalDiscount ||
        this.newBill.totalDiscount == 0 ||
        !this.newBill.totalDiscountType
      )
        return Math.round(totalByRow * 1000) / 1000;
      if (this.newBill.totalDiscountType.name == "₺")
        totalByRow -= this.newBill.totalDiscount;
      else if (this.newBill.totalDiscountType.name == "%")
        totalByRow -= (totalByRow * this.newBill.totalDiscount) / 100;
      else return Math.round(totalByRow * 1000) / 1000;
      return Math.round(totalByRow * 1000) / 1000;
    },
  },
  mounted: function () {
    this.paymentMethods = getDefaultPaymentMethods();
  },
  created: async function () {
    this.branches = await getBranchNameList2();
  },
  watch: {
    selectedBranch(val) {
      if (val) {
        this.suppliers = [];
        this.getSupplierNameSelectList();
      }
    },
    selectedSupplier(val) {
      if (val) {
        this.distributors = [];
        this.newBill.distributor = null;
        this.selectedDistributor = null;
        if (val.hasAnyDistributorForBranch) this.getDistributorNameList();
        this.newBill.supplier = val;
        this.newBill.billEntries = [];
        this.getStockNameListByDistributor();
      }
    },
    selectedDistributor(val) {
      if (val) {
        this.newBill.distributor = val;
      }
    },
    isActive: function (val) {
      if (!val) {
        this.initValues();
        this.$validator.reset();
      }
    },
  },
};
</script>

<style>
#billEntry {
  border-bottom: 1px solid #00000020;
}

#billDetailHeadersCol {
  border-right: 1px solid #00000010;
  box-shadow: 6px 0px 3px -3px #00000020;
  display: block !important;
}

#newBillPopup .vs__selected-options {
  flex-wrap: nowrap !important;
}

#kdvType .vs__selected {
  margin: 0;
}

#kdvType .vs__selected-options {
  display: -webkit-inline-box !important;
}

#newBillPopup .vs__dropdown-menu {
  max-height: 25vh !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
  min-width: 100% !important;
  width: fit-content !important;
}

#discountType .vs__search {
  margin: 0;
  padding: 0;
}

#discountType .vs__selected {
  padding: 0;
}

#kdvValue .vs__search,
#kdvValue .vs__search:focus {
  margin: 0;
  padding: 0;
}

#newBillEntryList
  .vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none !important;
  transform: none !important;
}

#newBillEntryList .vs-con-input .vs-inputx {
  padding: 0.4rem;
}

#newBillEntryList .vs-table--content {
  height: calc(100vh - 300px);
  overflow: auto;
}

#newBillPopup .vs-popup .vs-popup--content {
  max-height: unset !important;
  padding: 0 !important;
}

#paymentMethodSelect .vs__dropdown-toggle {
  height: 27px;
}

#newBillTotalDiscountType,
#entryDiscountType {
  min-width: 50px !important;
  background: rgba(var(--vs-primary), 1);
}

#kdvValue .vs__actions {
  border-right: 1px solid #00000020;
}

#discountType .vs__selected-options {
  border-left: 1px solid #00000020;
}

#newBillEntryList .vs-table--thead th .vs-table-text {
  text-transform: unset !important;
}

#newBillEntryList {
  font-size: 12px !important;
}

#newBillEntryList .vs-con-tbody {
  background-color: white !important;
  border: none !important;
  height: 100%;
}

#newBillEntryList * {
  font-size: inherit;
}

#newBillEntryList thead {
  font-size: 0.85rem;
}

#newBillEntryList .vs__dropdown-toggle {
  border: none;
  border-bottom: 1px solid #00000035;
  border-radius: 0;
}

#newBillEntryList .vs-inputx {
  border: none !important;
  border-bottom: 1px solid #00000035 !important;
  border-radius: 0;
  font: inherit !important;
}

#billDetailRow .vs-inputx {
  border: none !important;
  border-bottom: 1px solid #00000035 !important;
  border-radius: 0;
  font: inherit !important;
  font-size: 12px !important;
}

#billDetailRow .vs__dropdown-toggle {
  border: none;
  border-bottom: 1px solid #00000035;
  border-radius: 0;
  font-size: 12px;
}

#billEntryListContent {
  max-height: 90vh;
  overflow-y: auto !important;
}
</style>
